// 此文件由 scripts/load-infisical-secrets.js 自动生成，请勿手动修改
// 配置来源: .env.general + Infisical

export const APP_CONFIG = {
  mode: 'staging',
  AWS_REGION: 'ap-northeast-1',
  OAUTH_DOMAIN: 'https://ap-northeast-1cnlqbhnq6.auth.ap-northeast-1.amazoncognito.com',
  LOG: '1',
  ENV_CONFIGS: {
    dev: {
      API: 'http://localhost:5050/',
      WS: 'ws://localhost:8765/',
      STOCK: 'ws://localhost:8766/'
    },
    test: {
      API: 'https://getaws.alpha-pilot.net/test/',
      WS: 'wss://getaws.alpha-pilot.net/test/ws/',
      STOCK: 'wss://getaws.alpha-pilot.net/test/stock_ws/'
    },
    prod: {
      API: 'https://0hukbihbjk.execute-api.ap-northeast-1.amazonaws.com',
      WS: 'wss://getaws.alpha-pilot.net/ws/',
      STOCK: 'wss://getaws.alpha-pilot.net/stock_ws/'
    }
  },
  USER_POOL_ID: 'ap-northeast-1_CnlqBHnq6',
  USER_POOL_WEB_CLIENT_ID: '76i04c6ms9bi6vdn37cdqojkrt',
  STRIPE_PRICE_ID_PRO: ''
} as const;
